import React from 'react'


function Banner() {
  return (
    <div>
       <div className="container-fluid m-0 p-0">
            <div className="row m-0">
                <div className="mainframe-video">
                    <div className="video-frame"></div>
                    <div className="col-lg-8 col-12 px-4">
                        <div className="head-tag pb-3">SEO & Digital Marketing</div>
                        <p className="head-para mb-0 px-lg-5 px-0 py-0">
                        Boosting Visibility and Driving Growth Through Strategic SEO and Digital Marketing.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default Banner
